export default "__VITE_ASSET__BpJnDfCE__"